import type { BadgeTone } from '@artosera/ui';
import { ETATS_EXPOSITION, type EtatExposition } from '@artosera/shared';

/** Teinte de pastille par état (même esprit que `oeuvres/statutUi.ts`). */
const TEINTE_PAR_ETAT = {
  brouillon: 'neutral',
  annoncee: 'reserved',
  en_cours: 'available',
  passee: 'withdrawn',
} as const satisfies Record<EtatExposition, BadgeTone>;

/** Les teintes que prennent les états : aussi celles du calendrier. */
export function teinteDeLEtat(etat: EtatExposition): (typeof TEINTE_PAR_ETAT)[EtatExposition] {
  return TEINTE_PAR_ETAT[etat];
}

/** États dans l'ordre de la liste (3.3 : « à venir / en cours / passées / brouillons »). */
export const ETATS_AFFICHES: readonly EtatExposition[] = [
  'annoncee',
  'en_cours',
  'passee',
  'brouillon',
];

export function estEtatConnu(valeur: string): valeur is EtatExposition {
  return (ETATS_EXPOSITION as readonly string[]).includes(valeur);
}
